import NewsHero from "../components/News/NewsHero";
import Breadcrumb from "../components/Breadcrumb";

const News = () => {
  return (
    <div>
      <Breadcrumb curPage={"News"} />
      <NewsHero />
    </div>
  );
};

export default News;
